import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import PropTypes from 'prop-types';
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const Container = styled.div`
  margin-top: ${p => p.marginTop || '30px'};
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledLoader = styled.div`
  border: ${p => p.borderWidth || '16px'} solid ${p => p.trackColor || '#f3f3f3'};
  border-top: ${p => p.borderWidth || '16px'} solid ${p => p.loaderColor || '#3498db'};
  border-radius: 50%;
  width: ${p => p.width || '120px'};
  height: ${p => p.height || '120px'};
  animation: ${spin} 2s linear infinite;
`;
export const Loader = ({
  width,
  height,
  marginTop,
  borderWidth,
  trackColor,
  loaderColor,
  isCentered
}) => {
  const Wrapper = isCentered ? ({
    children
  }) => React.createElement(Container, {
    marginTop: marginTop
  }, children) : ({
    children
  }) => React.createElement("div", null, children);
  return React.createElement(Wrapper, null, React.createElement(StyledLoader, {
    width: width,
    height: height,
    borderWidth: borderWidth,
    trackColor: trackColor,
    loaderColor: loaderColor
  }));
};
Loader.propTypes = {
  isCentered: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  marginTop: PropTypes.string,
  borderWidth: PropTypes.string,
  trackColor: PropTypes.string,
  loaderColor: PropTypes.string
};
Loader.defaultProps = {
  isCentered: true,
  width: '',
  height: '',
  marginTop: '',
  borderWidth: '',
  trackColor: '',
  loaderColor: ''
};